// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { HomeTemplate } from '../Home';
import { Text } from '../../atoms';
import { ConsoleGameTemplateProps } from './ConsoleGameTemplate.types';
import './ConsoleGameTemplate.scss';
import { cn } from '@brr-dev/classnames';
import { ZenithConsole } from '@zenith-game/react-console';

// Import the console styling
import '@zenith-game/react-console/dist/index.css';

export default function ConsoleGameTemplate({
    gameDisc,
    className,
    ...templateProps
}: ConsoleGameTemplateProps) {
    return (
        <HomeTemplate className={cn('console-game-template', className)} {...templateProps}>
            <div className="console-game-header-section">
                <div className="console-game-title-section">
                    <Text className="console-game-title">
                        <em>{gameDisc.gameTitle}</em>
                    </Text>
                    <Text className="console-game-description">{gameDisc.gameDescription}</Text>
                </div>
                <div className="console-game-toolbar-section">
                    {/*<Button*/}
                    {/*    type="ghost"*/}
                    {/*    size={buttonSize}*/}
                    {/*    iconRight={<AiOutlineQuestionCircle />}*/}
                    {/*    title="get help"*/}
                    {/*></Button>*/}
                </div>
            </div>
            <div className={cn('console-game-console-wrapper')}>
                <ZenithConsole gameDisc={gameDisc} />
            </div>
        </HomeTemplate>
    );
}
